export enum NOTIFICATION_OBJECT_TYPE {
	APPLICATION = 'APPLICATION',
	APPEAL = 'APPEAL'
}
